/** Map GET /entities/search rows to competitor entity search UI shape. */

import { mapCompetitorSocialAccounts } from "./competitorSocialMappers"
import { formatWorldCityLabel } from "../../store/slices/worldGeographySlice"

function formatEntityLocation(worldCity) {
  if (!worldCity || typeof worldCity !== "object") return ""
  const parts = []
  if (worldCity.name) parts.push(String(worldCity.name).trim())
  const state = worldCity.worldState
  if (state?.name) parts.push(String(state.name).trim())
  const country = state?.worldCountry?.name || worldCity.worldCountry?.name
  if (country) parts.push(String(country).trim())
  return parts.filter(Boolean).join(", ")
}

export function mapEntityWorldGeography(worldCity) {
  if (!worldCity || typeof worldCity !== "object") {
    return {
      country: "",
      countryId: null,
      city: "",
      cityId: null,
      location: "",
    }
  }

  const country = worldCity.worldState?.worldCountry ?? worldCity.worldCountry ?? null
  const cityLabel = formatWorldCityLabel(worldCity) || String(worldCity.name ?? "").trim()

  return {
    country: String(country?.name ?? "").trim(),
    countryId: country?.id ?? null,
    city: cityLabel,
    cityId: worldCity.id ?? null,
    location: formatEntityLocation(worldCity),
  }
}

export function normalizeEntitySearchList(payload) {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.data?.content)) return payload.data.content
  if (Array.isArray(payload?.data)) return payload.data
  if (Array.isArray(payload?.results)) return payload.results
  if (Array.isArray(payload?.content)) return payload.content
  if (Array.isArray(payload?.items)) return payload.items
  if (Array.isArray(payload?.entities)) return payload.entities
  return []
}

function trimStr(value) {
  return String(value ?? "").trim()
}

export function mapApiEntityToCompetitorEntity(row) {
  if (!row || row.id == null) return null

  const subBrandObj = row.subBrand ?? row.sub_brand ?? null
  const subBrandName = trimStr(
    subBrandObj?.subBrand ?? subBrandObj?.sub_brand ?? subBrandObj?.name,
  )
  const brandName = trimStr(
    subBrandObj?.brand?.brand ?? subBrandObj?.brand?.name ?? row.brand?.brand ?? row.brand?.name,
  )
  const geography = mapEntityWorldGeography(row.worldCity)
  const websiteUrl = String(row.websiteUrl ?? "").trim()
  const tripadvisorUrl = String(row.url ?? "").trim()

  return {
    id: String(row.id),
    entityId: row.id,
    property: String(row.name ?? "").trim(),
    type: "",
    location: geography.location,
    country: geography.country,
    countryId: geography.countryId,
    city: geography.city,
    cityId: geography.cityId,
    brand: brandName && brandName !== "Unknown" ? brandName : "",
    brandId: subBrandObj?.brand?.id ?? row.brand?.id ?? null,
    subBrand: subBrandName && subBrandName !== "Unknown" ? subBrandName : "",
    subBrandId: subBrandObj?.id ?? null,
    websiteUrl,
    tripadvisorUrl,
    socialChannels: mapCompetitorSocialAccounts(row.socialNetworkAccounts),
    clientIds: Array.isArray(row.clientIds) ? row.clientIds : [],
  }
}

export function mapApiEntitiesToCompetitorEntities(rows) {
  return (Array.isArray(rows) ? rows : [])
    .map(mapApiEntityToCompetitorEntity)
    .filter(Boolean)
}

export function entityToCompetitorDraft(entity) {
  if (!entity) return null
  return {
    entityId: entity.entityId ?? entity.id,
    id: String(entity.id ?? entity.entityId ?? ""),
    property: entity.property || "",
    type: entity.type || "",
    location: entity.location || "",
    country: entity.country || "",
    countryId: entity.countryId ?? null,
    city: entity.city || "",
    cityId: entity.cityId ?? null,
    brand: entity.brand || "",
    brandId: entity.brandId ?? null,
    subBrand: entity.subBrand || "",
    subBrandId: entity.subBrandId ?? null,
    websiteUrl: entity.websiteUrl || "",
    tripadvisorUrl: entity.tripadvisorUrl || "",
    socialChannels: (entity.socialChannels || []).map((sc, index) => ({
      id: sc.id || `sc-entity-${entity.id}-${index}`,
      accountId: sc.accountId ?? null,
      socialNetworkId: sc.socialNetworkId ?? null,
      channel: sc.channel,
      url: sc.url,
      username: sc.username || "",
      validated: Boolean(sc.url),
      confirmed: Boolean(sc.url),
      fromEntity: true,
    })),
  }
}

